import React from "react";
import { Spinner, Callout } from "@blueprintjs/core";
import { w3cwebsocket as W3CWebSocket } from "websocket";

import { Equipment } from "./Equipment";
import { Trans } from "react-i18next";
import { getBackendRoute } from "../../utils/AuthenticatedFetch";

export class EquipmentStandAlone extends React.Component {
  constructor(props) {
    super();
    this.state = {
      device_id: props.device,
      server_id: props.server,
      device_state: undefined,
      ws_error: false,
      msg_rcv: false,
    };
  }

  handleStateMessage(message) {
    try {
      const parsedmsg = JSON.parse(message.data);
      let equipment;
      if(parsedmsg.general){
        equipment = parsedmsg;
      }
      else{
        equipment = parsedmsg[`${this.state.device_id}_${this.state.server_id}`]
      }

      if(!equipment)
        this.setState({msg_rcv: true, device_state: equipment, ws_error: true })
      else
        //single state only cause filter on device id is applied
        this.setState({ device_state: equipment, msg_rcv: true })
    }
    catch (e) {
      console.error("cannot parse" + message.data);
      console.error("ERROR", e);
    }
  }

  componentDidMount() {
    this.client = new W3CWebSocket(`${getBackendRoute("WS")}/supervision/rt/${this.state.device_id}/${this.state.server_id}`, ["Bearer", localStorage.getItem("token")]);

    this.client.onopen = () => {
      console.log("WebSocket Client Connected");
    };

    this.client.onerror = (e) => {
      console.log("WebSocket Client Error");
      this.setState({ ws_error: true });
      // TODO: handle error and display a message, or do nothing ?
    };

    this.client.onmessage = (message) => { this.handleStateMessage(message);}
  }

  componentWillUnmount() {
    //close websockets when component unmount
    if (this.client !== undefined)
      this.client.close();
  }

  render() {
    return (
      <div>
        {this.state.ws_error ?
          <Callout intent="warning">
            <Trans>cannot retreive device's state</Trans>
          </Callout>
          :
          this.state.msg_rcv === false ? <Spinner /> :
            <Equipment
              eq={this.state.device_state}
              extended={this.props.extended}
              imgScale={this.props.imgScale || 0.5}
              displayAnimations={true}
              displayImages={this.props.displayImages !== undefined ? this.props.displayImages : true}
            />
        }
      </div>
    );
  }
}
